import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";

const defaultCountry: CountryCode = "US";

export const parsePhoneNumber = (phoneNumber: number | string) =>
  parsePhoneNumberFromString(String(phoneNumber), defaultCountry);
